import { addWeeks, format } from 'date-fns'
import { ru } from 'date-fns/locale'
import { computed } from 'vue'

import constants from '~/constants'

export const useDolyame = (totalAmount: MaybeRef<number | null>) => {
  type Installment = {
    amount: number
    date: string
  }

  const installmentsCount = 4
  const minTotalAmount = 4
  const maxTotalAmount = 30000

  const reactiveTotalAmount = ref(toValue(totalAmount) ?? 0)

  watchEffect(() => {
    reactiveTotalAmount.value = toValue(totalAmount) ?? 0
  })

  const areInstallmentsEqual = computed(() => {
    const amounts = installments.value.map((x: Installment): number => x.amount)

    return amounts.every((x: number): boolean => x === amounts[0])
  })
  const enableButton = computed(() => reactiveTotalAmount.value >= minTotalAmount && reactiveTotalAmount.value <= maxTotalAmount)
  const equalInstallmentAmount = computed(() => Math.floor(reactiveTotalAmount.value / installmentsCount))
  const installments = computed(() => {
    const today = new Date()
    const lastInstallmentAmount = reactiveTotalAmount.value - equalInstallmentAmount.value * (installmentsCount - 1)
    const installments: Installment[] = []

    for (let i = 0; i < installmentsCount; ++i) {
      installments.push({
        amount: i === installmentsCount - 1 ? lastInstallmentAmount : equalInstallmentAmount.value,
        date: i === 0
          ? 'Сегодня'
          : format(addWeeks(today, i * 2), constants.dateTimeFormats.dateShort, { locale: ru })
      })
    }

    return installments
  })

  return { areInstallmentsEqual, enableButton, equalInstallmentAmount, installments, installmentsCount }
}
